<template>
  <div
    class="step"
    v-bind:class="{
      'step-current': number === current,
      'step-past': number < current,
      'step-failed': number === current && failed
    }"
  >
    <div class="step-line-wrapper" v-if="number > 1">
      <div class="step-line"></div>
    </div>
    <div class="d-flex align-items-center position-relative">
      <div class="step-circle">
        <div class="step-dot" v-if="number === current && !failed"></div>
        <div v-if="number < current">
          <svg
            class="step-icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <div class="step-cross" v-if="number === current && failed">
          <svg
            class="step-icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
      </div>
      <div class="flex-fill ml-3">
        <slot
          v-bind:is-current="number === current"
          v-bind:is-past="number < current"
          v-bind:is-future="number > current"
          v-bind:has-failed="number === current && failed"
        ></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProcessStep",
  props: {
    number: { type: Number, required: true },
    current: { type: Number, required: true },
    failed: { type: Boolean, default: () => false }
  }
};
</script>

<style lang="scss">
$primary: darken(#428bca, 6.5%);

@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";

.step-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  border-width: 2px;
  border-style: solid;
  border-color: $gray-500;
  background-color: white;
  width: 40px;
  height: 40px;
  min-width: 40px;
}

.step-current {
  .step-circle {
    border-color: $primary;
  }

  .step-dot {
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background-color: $primary;
  }

  .step-line {
    background-color: $primary;
  }
}

.step-past {
  .step-circle {
    background-color: $primary;
    border-color: $primary;
  }

  .step-line {
    background-color: $primary;
  }
}

.step-failed {
  .step-circle {
    background-color: $danger;
    border-color: $danger;
  }
}

.step-line-wrapper {
  display: flex;
  justify-content: center;
  height: 40px;
  width: 40px;
  margin: -5px 0;
}

.step-line {
  background-color: $gray-500;
  width: 2px;
  height: 100%;
}

.step {
  color: $gray-600;
}

.step-title {
  text-transform: uppercase;
  font-weight: bold;
  line-height: 1rem;
  color: $gray-800;
}

.step-icon {
  width: 24px;
  height: 24px;
  color: white;
}
</style>
